import React from 'react';
import { Star } from 'lucide-react';
export function HeroSection() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-24 pb-16 px-4 min-h-[90vh] flex flex-col justify-center items-center overflow-hidden bg-radial-gold" data-id="element-144">
      <div className="max-w-4xl mx-auto text-center z-10" data-id="element-145">
        <div className="animate-fade-in-up" data-id="element-146">
          <h2 className="text-brand-gold font-bold tracking-widest text-sm md:text-base mb-6 uppercase" data-id="element-147">
            EL SISTEMA QUE USAN LOS EJECUTIVOS DE ÉLITE PARA ASCENDER
          </h2>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-8 bg-gradient-to-b from-brand-text to-brand-muted bg-clip-text text-transparent" data-id="element-148">
            Dominá el Lenguaje
            <br data-id="element-149" />
            del Poder Corporativo
            <br data-id="element-150" />
            y Convertite en
            <br data-id="element-151" />
            el Profesional Que
            <br data-id="element-152" />
            Nadie Puede Ignorar
          </h1>
        </div>

        <div className="animate-fade-in-up animation-delay-200 relative mx-auto w-full max-w-[600px] mb-8" data-id="element-153">
          <div className="absolute inset-0 glow-gold rounded-xl z-0" data-id="element-154" />
          <img src="https://cdn.magicpatterns.com/uploads/u3B3sj3jQFf5xggAYQWpmR/heylloyd-image-1773759479106.png" alt="Proyecto Elite - 6 Tomos PDF" width={600} height={400} fetchPriority="high" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" data-id="element-155" />
        </div>

        <div className="animate-fade-in-up animation-delay-400 max-w-2xl mx-auto" data-id="element-156">
          <p className="text-brand-text/90 text-lg md:text-xl mb-6 leading-relaxed" data-id="element-157">
            El pack de 6 tomos PDF que te enseña a proyectar autoridad real,
            negociar tu valor con confianza y posicionarte como clave en
            cualquier organización — sin cursos largos, sin coaches caros y sin
            actuar diferente a lo que sos.
          </p>

          <div className="flex items-center justify-center space-x-1 mb-8 text-brand-gold-light" data-id="element-158">
            {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-159" />)}
            <span className="text-brand-text text-sm ml-2 font-medium" data-id="element-160">
              Más de 3.200 profesionales ya cambiaron su presencia ejecutiva
            </span>
          </div>

          <button onClick={scrollToCheckout} className="w-full sm:w-auto px-8 py-5 bg-brand-gold hover:bg-brand-gold-light text-brand-black font-bold text-lg md:text-xl rounded-lg transition-all transform hover:scale-105 animate-pulse-gold shadow-lg mb-4" data-id="element-161">
            QUIERO EL CÓDIGO DEL ASCENSO →
          </button>

          <p className="text-brand-muted text-sm font-medium" data-id="element-162">
            ✓ Acceso inmediato · ✓ 100% PDF Digital · ✓ Garantía de 7 días
          </p>
        </div>
      </div>
    </section>;
}